import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Swallow harmless "Script error." cross-origin noise from TradingView embed
// so it doesn't trip CRA's runtime-error overlay in dev.
window.addEventListener(
  "error",
  (e) => {
    if (!e.message || e.message === "Script error." || e.filename === "") {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
